(() => {
  const STORAGE_KEY = 'gr_home_featured_products_toggle_v1';
  const ITEMS_SHOWN = 8;

  const mulberry32 = (a) => {
    return () => {
      let t = (a += 0x6d2b79f5);
      t = Math.imul(t ^ (t >>> 15), t | 1);
      t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  };

  const shuffleInPlace = (arr, rng) => {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(rng() * (i + 1));
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  };

  const init = () => {
    const grid = document.querySelector('[class~="gr-home-featured-products__grid"]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('[data-gr-home-featured-products-item]'));
    if (items.length <= ITEMS_SHOWN) return;

    let toggle = 0;
    try {
      toggle = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    } catch (e) {
      toggle = 0;
    }

    toggle += 1;
    try {
      localStorage.setItem(STORAGE_KEY, String(toggle));
    } catch (e) {
      // Se o navegador bloquear localStorage, ainda assim alterna via fallback de horário.
    }

    const nowSeed = Date.now() % 1000000;
    const rng = mulberry32(toggle + nowSeed);

    // Embaralha a lista e mostra apenas os primeiros 8.
    const shuffled = items.slice();
    shuffleInPlace(shuffled, rng);

    items.forEach((el) => {
      el.classList.add('is-hidden');
    });

    for (let i = 0; i < ITEMS_SHOWN; i++) {
      const el = shuffled[i];
      if (el) el.classList.remove('is-hidden');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

